export const galleryImages = [
  {
    url: 'https://static.readdy.ai/image/fef20157eea1fb1d08dc062c0ae5461e/44de4b574d393451116b95c9ebc9cd3d.jpeg',
    alt: 'King Square Club Interior'
  },
  {
    url: 'https://static.readdy.ai/image/fef20157eea1fb1d08dc062c0ae5461e/7c3c8de8e414d8bbbf17ef2236b8a186.png',
    alt: 'Party Night'
  },
  {
    url: 'https://static.readdy.ai/image/fef20157eea1fb1d08dc062c0ae5461e/711fcc8b665a1d86e84b70653777ff65.jpeg',
    alt: 'VIP Lounge'
  },
  {
    url: 'https://static.readdy.ai/image/fef20157eea1fb1d08dc062c0ae5461e/ba2841c0096f99d4dbdb7f5976c3bbdb.png',
    alt: 'DJ Performance'
  },
  {
    url: 'https://static.readdy.ai/image/fef20157eea1fb1d08dc062c0ae5461e/8d92c3000ccbdf14a9237cb2f8be6715.jpeg',
    alt: 'Premium Bar'
  },
  {
    url: 'https://static.readdy.ai/image/fef20157eea1fb1d08dc062c0ae5461e/4df6dcb0d50b48c95d3dd423fe2e5588.jpeg',
    alt: 'Champagne Service'
  },
  {
    url: 'https://static.readdy.ai/image/fef20157eea1fb1d08dc062c0ae5461e/7e13a45b68bdedb6552cfb3ec461e442.jpeg',
    alt: 'Dance Floor'
  },
  {
    url: 'https://static.readdy.ai/image/fef20157eea1fb1d08dc062c0ae5461e/c8461a9fa36d918264a316f6bf4463f0.jpeg',
    alt: 'Private Booth'
  }
];